<template>
    <div class="_content">
        <div class="main">

            <div class="content">

                <div class="result">
                    <img :src="isSucess ? icon1 : icon2" alt="" class="icon1">
                    <p class="name">{{ isSucess ? '券码核销成功' : '券码核销失败' }}</p>
                    <p v-if="isSucess" class="text">核销券数<span>{{ dataInfo.verifyNum }}</span>张，核销收入<span>￥{{
                        dataInfo.verifyIncome }}</span></p>
                    <p v-else class="text">{{ tips||'请联系您的商户专员或小鲲车服客服处理！' }}</p>
                </div>

                <div class="goods" v-if="isSucess">
                    <div class="cell-goods">
                        <img :src="dataInfo.goodsImg" alt="暂无图片" class="pic">
                        <div class="cell-flex">
                            <p class="one-limit cell-name">{{ dataInfo.title }}</p>
                            <p class="cell-price">结算单价<span>￥{{ dataInfo.settlementPrice }}</span></p>
                        </div>
                    </div>

                    <div class="cell-code" v-for="(item, index) in dataInfo.detail" :key="index">
                        <div class="code code-num">
                            <p class="code-code">券码：{{ item.certificateId }}</p>
                            <p class="code-status" v-if="item.status == 'ORDER_FINISH'">已核销</p>
                            <p class="code-status code-status-grey" v-else-if="item.status == 'CANCEL'">已撤销核销</p>
                        </div>
                        <div class="code code-desc">
                            <p class="code-text">核销1小时内可以撤销核销</p>
                            <p class="code-btn" v-if="item.status == 'ORDER_FINISH'"
                                @click="currentItem = item; isShow = true">
                                撤销核销</p>
                        </div>
                    </div>
                </div>

                <div class="err-btn" v-else>
                    <p v-call>联系客服</p>
                    <p @click="toHome()">返回首页</p>
                </div>
            </div>

            <div class="footer" v-if="isSucess">
                <p @click="toView()">查看核销明细</p>
                <p @click="toHome()">返回首页</p>
            </div>
        </div>

        <van-dialog v-model="isShow" class="dialog-result" title="撤销当前核销？" showCancelButton confirmButtonText='确认撤销'
            cancelButtonText='暂不撤销' get-container=".day-record" @confirm="sureRevoke">
            <div class="text">
                请和消费者确认后再进行撤销操作，撤销后该订单将不计入核销订单和核销收入。
            </div>
        </van-dialog>
    </div>
</template>

<script>
import config from '@/configs/config'
import debounce from 'lodash/debounce'
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
    data() {
        return {
            icon1: 'https://res.xiaokunkeji.cn/image/2023/12/13/5f83129518f9435f8e1164fc214e9ee4.png',
            icon2: 'https://res.xiaokunkeji.cn/image/2023/12/13/8f44c0445f0549418588fdd8154acd72.png',
            dataInfo: {},
            verifyNum: tuhu.getParam('verifyNum') || '',
            verifyIncome: tuhu.getParam('verifyIncome') || '',
            isSucess: tuhu.getParam('isSucess') || '',
            shopId: tuhu.getParam('shopId') || '',
            goodsOrderId: tuhu.getParam('goodsOrderId') || '',
            tips: tuhu.getParam('tips') || '',
            isShow: false,
            currentItem: {}
        }
    },

    created() {
        if (this.isSucess) {
            this.getResultList()
        }
    },

    methods: {

        async getResultList() {
            tuhu.showIndicator()
            tuhu
                .fetch(`${config.apis.GET_TIKTOK_MERCHANT_LIST}/${this.goodsOrderId}`)
                .then((data) => {
                    if (data.code === '200') {
                        tuhu.hideIndicator();
                        this.dataInfo = data.data
                    }
                    else {
                        tuhu.hideIndicator();
                        tuhu.toast(data.message)
                    }
                })
        },

        //撤销核销接口
        sureRevoke: debounce(async function () {
            const res = await tuhu.fetch(`${config.apis.QUERY_TIKTOK_CANCEL}`, {
                method: "post",
                body: JSON.stringify({
                    providerOrderId: this.currentItem.providerOrderId,
                }),
            })
            if (res && res.code === '200') {
                this.getResultList()
            } else {
                tuhu.toast(res.message || "网络错误");
            }
        }, 500),


        toView() {
            tuhu.navigateTo({
                url: '/pages/dayRecord/index',
                query: {
                    date: moment().format("YYYY-MM-DD"),
                    shopId: this.shopId,
                }
            })
        },

        toHome() {
            tuhu.navigateTo({
                url: '/pages/home/index'
            })
        }
    }
}
</script>

<style lang="less" scoped>
._content {
    width: 100%;
    height: 100%;
    background: #F8F9FB;
}

.icon1 {
    width: 4.25rem;
    height: 4.25rem;
    margin: 0 auto 1rem;
}

.main {
    height: 100%;
    display: flex;
    flex-direction: column;

    .content {
        flex: 1;
        overflow-y: auto;

        .result {
            background: #fff;
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;

            .name {
                color: #09090A;
                font-size: .9rem;
                text-align: center;
                line-height: 1.1rem;
                margin-bottom: .5rem;
                font-weight: 600;
            }

            .text {
                color: #333333;
                font-size: .65rem;
                text-align: center;

                >span {
                    color: #176DF9;
                    font-size: .6.3rem;
                }
            }
        }

        .goods {
            padding: .75rem .75rem .3rem;
            background: #fff;
            margin: .75rem;
        }

        .cell-goods {
            display: flex;
            padding-bottom: .75rem;
            border-bottom: 1px dashed #C6C6C6;
            margin-bottom: .75rem;

            .pic {
                width: 3.5rem;
                height: 3.5rem;
                min-width: 3.5rem;
                margin-right: .75rem;
                border-radius: .4rem;
            }

            .cell-flex {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                overflow: hidden;

                .cell-name {
                    color: #09090A;
                    font-size: .8rem;
                    font-weight: 600;

                }

                .cell-price {
                    color: #333333;
                    font-size: .65rem;
                    display: flex;
                    align-items: center;

                    >span {
                        color: #176DF9;
                        font-size: .65rem;
                    }
                }
            }
        }

        .cell-code {
            background: #F8F9FB;
            border-radius: .4rem;
            padding: .75rem .5rem;
            margin-bottom: .5rem;

            .code {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .code-num {
                margin-bottom: .5rem;

                .code-code {
                    color: #09090A;
                    font-size: .65rem;
                    font-weight: 600;
                }

                .code-status {
                    color: #09090A;
                    font-size: .6rem;
                }

                .code-status-grey {
                    color: #808080;
                }
            }

            .code-desc {
                .code-text {
                    color: #808080;
                    font-size: .6rem;
                }

                .code-btn {
                    width: 3.4rem;
                    height: 1.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #F8F9FB;
                    border-radius: 1rem;
                    border: 1px solid #176DF9;
                    font-size: .6rem;
                    color: #176DF9;

                }
            }
        }

        .err-btn {
            display: flex;
            align-items: center;
            padding: 0 .75rem;
            justify-content: space-between;
            margin-top: 1.5rem;

            >P {
                width: 8.25rem;
                height: 2rem;
                border-radius: 1.1rem;
                font-size: .8rem;
                line-height: 2rem;
                text-align: center;
            }

            P:first-child {
                color: #333333;
                background: #EEEEEE;
            }

            P:last-child {
                color: #fff;
                background: #176DF9;
            }
        }
    }

    .footer {
        height: 3.2rem;
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0rem -0.1rem 0.6rem 0rem #E8EBF1;
        padding: 0 .75rem;
        justify-content: space-between;

        >P {
            width: 8.25rem;
            height: 2rem;
            border-radius: 1.1rem;
            font-size: .8rem;
            line-height: 2rem;
            text-align: center;
        }

        P:first-child {
            color: #333333;
            background: #EEEEEE;
        }

        P:last-child {
            color: #fff;
            background: #176DF9;
        }
    }
}


.dialog-result {
    width: 85%;

    .text {
        margin: 1.2rem auto;
        padding: 0 .75rem;
        height: 2.2rem;
        font-size: 0.7rem;
        color: #333333;
        line-height: 1.1rem;
    }

    :deep(.van-button::before) {
        background-color: transparent;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/record/writeResult.vue